module.exports = __webpack_public_path__ + "img/IconPhone.dec00903.svg";